export default (form) => {
    const checkboxToggles = Array.from(form.querySelectorAll('.js-checkbox-toggle'));

    checkboxToggles.forEach((toggle) => {
        const target = form.querySelector(toggle.dataset.showOnToggle);
        if (target) {
            toggle.querySelector('input[type=checkbox]').addEventListener('change', () => {
                target.classList.toggle('toggled');
            });
        }
    });
};
